import script from "./FarmCard.vue?vue&type=script&setup=true&lang=js"
export * from "./FarmCard.vue?vue&type=script&setup=true&lang=js"

export default script